export default __webpack_public_path__ + "static/media/Episode_1_Andrea.f22312b2.png";